// src/components/Header.jsx
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
// import styles from './Header.module.css'; // REMOVED

const navLinks = [
    { title: 'Home', path: '/' },
    { title: 'How It Works', path: '/how-it-works' },
    { title: 'Topics', path: '/topics' },
    { title: 'Chat Rooms', path: '/chat-rooms' },
    { title: 'About & FAQ', path: '/about-faq' },
];

const Header = () => {
    return (
        <header className="header-root">
            <div className="header-container">
                <RouterLink to="/" className="header-logo">
                    NYC Connect
                </RouterLink>
                
                <nav className="header-nav-bar">
                    {navLinks.map((link) => (
                        <RouterLink 
                            key={link.title} 
                            to={link.path} 
                            className="header-nav-link"
                        >
                            {link.title}
                        </RouterLink>
                    ))}
                </nav>

                <div className="header-auth-buttons">
                    <RouterLink to="/login" className="header-auth-button header-login-button">
                        Login
                    </RouterLink>
                    <RouterLink to="/signup" className="header-auth-button header-signup-button">
                        Sign up
                    </RouterLink>
                </div>
            </div>
        </header>
    );
};

export default Header;